import { Ellipsoid, WGS84_ELLIPSOID } from 'gecko-3d-tiles-renderer'
import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { Matrix4 } from 'three'

export interface TilesContextType {
  // Objects associated with the Tile Renderer
  tilesEllipsoid: Ellipsoid
  setTilesEllipsiod: Dispatch<SetStateAction<Ellipsoid>>

  tilesMatrix: Matrix4
  setTilesMatrix: Dispatch<SetStateAction<Matrix4>>
}

export const TilesContext = createContext<TilesContextType | undefined>(
  undefined
)

export const TilesContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [tilesEllipsoid, setTilesEllipsiod] =
    useState<Ellipsoid>(WGS84_ELLIPSOID)

  const [tilesMatrix, setTilesMatrix] = useState<Matrix4>(new Matrix4())
  return (
    <TilesContext.Provider
      value={{
        tilesEllipsoid,
        setTilesEllipsiod,
        tilesMatrix,
        setTilesMatrix,
      }}>
      {children}
    </TilesContext.Provider>
  )
}

export const useTilesContext = () => {
  const context = useContext(TilesContext)
  if (!context)
    throw new Error(
      'useTilesContext() must be used within TilesContextProvider'
    )
  return context
}
